<template>
  <div class="education">
    <div class="tabs">
      <span></span>教育经历
      <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
        <i v-show="isEdit" class="tabs_one" @click="goEssentialInformation"></i>
      </el-tooltip>
    </div>
    <el-form :inline="true" :label-position="labelPosition" label-width="100px" ref="ruleFormDataOne"
      :model="FormDataOne">

      <!-- <el-form-item prop="company_name" > -->
      <div class="work_experience_wrap" v-for="(domain, index) in FormDataOne.education" :key="index">
        <el-form-item label="学校" :prop="'education.' + index + '.schoolName'" :rules="{
      required: true, message: '请输入学校名称', trigger: 'blur'
    }">
          <el-autocomplete v-model="domain.schoolName" :fetch-suggestions="debounceName" @select="handleSelect"
            :disabled="isDis" placeholder="请输入学校名称" :trigger-on-focus="false"></el-autocomplete>
        </el-form-item>

        <el-form-item style="width:55%" label="就读时间" :prop="'education.' + index + '.school_time'" class="school_time"
          :rules="{
      required: true, message: '请选择就读时间', trigger: 'blur'
    }">
          <el-date-picker v-model="domain.school_time" type="daterange" :disabled="isDis" :unlink-panels="true"
            range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="最高学历" :prop="'education.' + index + '.userDegree'" class="user_degree" :rules="{
      required: true, message: '请选择最高学历', trigger: 'blur'
    }">
          <el-select v-model="domain.userDegree" placeholder="请选择最高学历" :disabled="isDis">
            <el-option label="本科" value=1></el-option>
            <el-option label="硕士" value=2></el-option>
            <el-option label="博士" value=3></el-option>
            <el-option label="其他" value=4></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所学专业" :prop="'education.' + index + '.specialtyName'" :rules="{
      required: true, message: '请输入所学专业', trigger: 'blur'
    }">
          <el-autocomplete v-model="domain.specialtyName" :fetch-suggestions="specialty" @select="handleSelect"
            :disabled="isDis" placeholder="请输入所学专业" :trigger-on-focus="false"></el-autocomplete>
        </el-form-item>
      </div>
    </el-form>
    <!-- <div v-show="isAddWorkExperience" class="add_work_experience" @click="addWorkExperience"><i></i><span>添加教育经历</span>
    </div> -->
    <div class="btn" v-if="!isDis">
      <el-button class="cancel" @click="cancel">取消</el-button>
      <el-button class="preservation" @click="preservation('ruleFormDataOne')">保存</el-button>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce"; // 防抖函数
export default {
  props: {
    userInfo: {
      type: Object
    }
  },

  watch: {
    userInfo: {
      handler (newVale, oldVale) {
        console.log(newVale, "newVale");
        if (newVale.num === 1) {
          this.id = newVale.id
          this.auditStatus = newVale.auditStatus
          this.certificateUrls = newVale.certificateUrls
          if (newVale.studyList !== null) {
            if (newVale.studyList.length !== 0) {
              this.FormDataOne.education = newVale.education

            }

          }
          if (!this.dataObj) {
            console.log(this.dataObj, "this.dataObj");
            this.dataObj = JSON.parse(JSON.stringify(this.FormDataOne))
          }
          // this.dataObj =  { ...this.FormDataOne } // 解构对象，取消操作用解构对象

        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    isEdit () {
      if (this.auditStatus === 1) {
        return false
      } else {
        return this.isDis
      }
    },
    isAddWorkExperience () {
      if (!this.isDis) {
        return this.FormDataOne.education.length >= 3 ? false : true
      } else {
        return false
      }
    },
  },
  data () {
    return {
      // certificateUrls:[],
      auditStatus: null,
      FormDataOne: {
        education: [
          {
            schoolName: "",
            school_time: [],
            userDegree: "",
            specialtyName: "",
            specialty: "",
          }
        ],
      },
      labelPosition: "left",
      isDis: true,
      flag: true,
      id: null,
      debounceName: "",
      dataObj: ""
    };
  },
  created () {
    this.debounceName = debounce(this.querySearchAsync, 500)
    this.specialty = debounce(this.querySpecialty, 500)
  },
  methods: {
    goEssentialInformation () {
      this.isDis = false
    },
    handleSelect (item) {
      console.log(item);
    },
    // 获取所有学校
    async querySearchAsync (queryString, cb) {
      if (!queryString) {
        return
      }
      const { result, success } = await this.catReq1Service("/v1/userRegister/querySchoolNameList", { name: queryString });
      if (success) {
        let list = []
        result.filter(item => list.push({ value: item }))
        cb(list)
      }
    },
    //this.querySpecialty
    async querySpecialty (queryString, cb) {
      if (!queryString) {
        this.loadAll();
        return
      }
      const { result, success } = await this.catReq1Service("/v1/userRegister/querySpecialtyNameList", { name: queryString });
      if (success) {
        let list = []
        result.filter(item => list.push({ value: item }))
        cb(list)
      }
    },
    //添加节点
    addWorkExperience () {
      this.FormDataOne.education.push(
        {
          schoolName: "",
          school_time: [],
          userDegree: "",
          specialtyName: "",
        });
    },
    preservation (ruleFormDataOne) {
      let _this = this
      this.$refs[ruleFormDataOne].validate(async (valid) => {
        if (valid) {
          let url = "/v1/userRegister/add_or_update_register_info"
          let myUser = JSON.parse(localStorage.getItem("myUser"))
          let studyList = JSON.parse(JSON.stringify(_this.FormDataOne.education))// [..._this.FormDataOne.work_experience]
          // let studyList = [..._this.FormDataOne.education]
          studyList.forEach(item => {
            item.studyStartTime = item.school_time[0]
            item.studyEndTime = item.school_time[1]
            delete item.school_time
          })
          let params = {
            id: this.id,
            auditStatus: this.auditStatus === 0 ? 0 : 2,
            userId: myUser.id,
            studyList,
            certificateUrls: this.certificateUrls
          }
          const res = await this.catReq1Service(url, params)
          if (res.resultCode === "1") {
            this.isDis = true;
            this.dataObj = JSON.parse(JSON.stringify(this.FormDataOne))
            this.$emit("succe", res.result)
          }

        } else {

          return false;
        }
      });

    },
    cancel () {
      this.$refs['ruleFormDataOne'].clearValidate();
      // this.$refs['ruleFormDataOne'].resetFields();
      this.FormDataOne = JSON.parse(JSON.stringify(this.dataObj))
      this.isDis = true;
    },
  },
};
</script>

<style lang="less" scoped>
.education {
  .tabs {
    display: flex;
    font-size: 16px;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(28, 28, 29, 1);
    margin-bottom: 20px;
    span {
      width: 4px;
      height: 16px;
      background: rgba(30, 134, 230, 1);
      margin-right: 5px;
    }
    .tabs_one {
      width: 16px;
      height: 16px;
      cursor: pointer;
      display: inline-block;
      background: url("../../assets/imgs/authentication/modify_normal.png")
        no-repeat;
      background-size: cover;
      margin-left: 10px;
      &:active {
        background: url("../../assets/imgs/authentication/modify_press.png")
          no-repeat;
      }
    }
  }
  /deep/.el-form {
    .work_experience_wrap {
      margin-bottom: 10px;
      .el-input {
        width: 202px;
      }
      .el-form-item {
        width: 40%;
        text-align: left;
        &.work_time {
          position: relative;
          left: -145px;
          width: 53%;
        }
        &.position {
          position: relative;
          left: 55px;
        }
      }
    }
    display: flex;
    flex-wrap: wrap; //flex-grow
  }
  .add_work_experience {
    display: flex;
    cursor: pointer;
    float: left;
    margin-left: 10px;
    i {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      background: url("../../assets/imgs/editor/add_to_normal.png") no-repeat;
      background-size: cover;
    }
    span {
      display: inline-block;
      line-height: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-left: 5px;
    }
  }
  .btn {
    width: 100%;
    text-align: right;
    .el-button {
      width: 80px;
      height: 36px;
      box-sizing: border-box;
      font-family: Microsoft YaHei;
      font-size: 16px;
      line-height: 0;
    }
    .cancel {
      background: rgba(219, 239, 255, 1);
      border: 1px solid rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
      border-radius: 4px;
    }
    .preservation {
      background: rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
      border-radius: 4px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-left: 50px;
    }
  }
}
</style>
